export default __webpack_public_path__ + "static/media/gallery_12.a4eaae9d.jpg";